import React from 'react';
import { ImportModal } from '../import/ImportModal';
import { ExportModal } from '../export/ExportModal';
import { ReportsMenu } from '../ReportsMenu'; 
import { QuickSurveyModal } from '../QuickSurveyModal';
import { HighPolePOISelector } from '../highpole';
import { FileUploadModal } from '../FileUploadModal';
import { BookSurveyModal } from '../BookSurveyModal';

export const Modals = ({ states, handlers, activeSurvey, teamMembers, onToast }) => {
  return (
    <>
      {/* Import Modal */}
      <ImportModal
        isOpen={states.showImport}
        onClose={() => handlers.setShowImport(false)}
        surveyId={activeSurvey?.id || ''}
        onImportComplete={() => {
          onToast({
            type: 'success',
            message: 'Import completed successfully'
          });
          handlers.setShowImport(false);
        }}
      />

      {/* Export Modal */}
      <ExportModal
        isOpen={states.showExport}
        onClose={() => handlers.setShowExport(false)}
        survey={activeSurvey}
      />

      {/* Reports Menu */}
      <ReportsMenu
        isOpen={states.showReports}
        onClose={() => handlers.setShowReports(false)}
      />

      {/* Quick Survey Modal */}
      <QuickSurveyModal
        isOpen={states.showQuickSurvey}
        onClose={() => handlers.setShowQuickSurvey(false)}
        onSave={(data) => {
          onToast({
            type: 'success',
            message: 'Quick survey saved successfully'
          });
          handlers.setShowQuickSurvey(false);
        }}
      />

      {/* High Pole Survey Modal */}
      {states.showHighPoleSurvey && (
        <HighPolePOISelector
          onClose={() => handlers.setShowHighPoleSurvey(false)}
          onSave={(data) => {
            onToast({
              type: 'success',
              message: 'High pole measurement saved successfully'
            });
            handlers.setShowHighPoleSurvey(false);
          }}
        />
      )}

      {/* File Upload Modal */}
      <FileUploadModal
        isOpen={states.showFileUpload}
        onClose={() => handlers.setShowFileUpload(false)}
        surveyId={activeSurvey?.id}
        onUpload={(urls) => {
          onToast({
            type: 'success',
            message: `${urls.length} file(s) uploaded successfully`
          });
          handlers.setShowFileUpload(false);
        }}
      />

      {/* Book Survey Modal */}
      <BookSurveyModal
        isOpen={states.showBookSurvey}
        onClose={() => handlers.setShowBookSurvey(false)}
      />
    </>
  );
};